module.exports = __webpack_public_path__ + "img/sidebar-1.34be2014.png";